import React, { useState, useEffect, useCallback } from 'react';
import { getApprovedUpdates, downloadArchivedFile } from '../api/services';
import { downloadBase64File } from '../Utils/FileHelpers';

function History({ setFeedback }) {
  const [historicalFiles, setHistoricalFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setIsLoading(true);
        const rawFiles = await getApprovedUpdates();
        const formattedFiles = rawFiles.map(file => ({
          Key: file.Key,
          fileName: file.Key.split('/').pop(),
          lastModified: file.LastModified,
          size: file.Size,
        }));

        // Ordenar los archivos por fecha de modificación, del más reciente al más antiguo
        const sortedFiles = formattedFiles.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));

        setHistoricalFiles(sortedFiles);
      } catch (error) {
        console.error('Error fetching historical files:', error);
        setFeedback({ message: 'Error al cargar el historial de archivos.', type: 'error' });
        setFeedback({ message: error.summary || error.message || 'Error al cargar el historial de archivos.', type: 'error' });
      } finally {
        setIsLoading(false);
      }
    };
    fetchHistory();
  }, [setFeedback]);

  const handleDownload = useCallback(async (fileKey) => {
    setFeedback({ message: `Descargando y convirtiendo ${fileKey.split('/').pop()}...`, type: 'loading' });
    try {
      const responseData = await downloadArchivedFile(fileKey);
      if (responseData.fileContent && responseData.fileName) {
        downloadBase64File(responseData.fileContent, responseData.fileName, responseData.mimeType);
        setFeedback({ message: 'Archivo descargado con éxito.', type: 'success' });
      } else {
        throw new Error("La respuesta del servidor no contenía un archivo válido.");
      }
    } catch (error) {
      console.error("Error al descargar archivo histórico:", error);
      setFeedback({ message: 'No se pudo descargar el archivo.', type: 'error' });
      setFeedback({ message: error.summary || error.message || 'No se pudo descargar el archivo.', type: 'error' });
    }
  }, [setFeedback]);

  if (isLoading) {
    return <section><h2>Historial de Actualizaciones</h2><div className="spinner" /></section>;
  }

  return (
    <section>
      <h2>Historial de Actualizaciones de Precios</h2>
      <div className="table-wrapper">
        <table className="history-table">
          <thead>
            <tr>
              <th>Nombre del Archivo</th>
              <th>Fecha de Creación</th>
              <th>Tamaño</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {historicalFiles.length > 0 ? historicalFiles.map(file => (
              <tr key={file.Key}>
                <td>{file.fileName}</td>
                <td>{new Date(file.lastModified).toLocaleString('es-CO')}</td>
                <td>{`${(file.size / 1024).toFixed(2)} KB`}</td>
                <td>
                  <button onClick={() => handleDownload(file.Key)} className="download-link">
                    Descargar Excel
                  </button>
                </td>
              </tr>
            )) : (
              <tr><td colSpan="4">No hay archivos en el historial.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default History;